"use strict";

define('service/push.state',['underscore', 'backbone', 'appkit/service', '../config'], function (_, Backbone, Service, config) {
  var PushStateService = Service.extend({
    initialize: function initialize() {
      if (config.usePushState) {
        $(document).on('click', 'a[href]', _.bind(this.onDocumentLinkClick, this));
      }
    },
    isRequestingNewTab: function isRequestingNewTab(ev) {
      return ev.metaKey || ev.ctrlKey;
    },
    cleanLinkHref: function cleanLinkHref(src) {
      if (src.indexOf(Backbone.history.root) === 0) {
        src = src.slice(Backbone.history.root.length);
      }
      return src;
    },
    onDocumentLinkClick: function onDocumentLinkClick(ev) {
      var src = $(ev.currentTarget).attr('href');
      if (this.isRequestingNewTab(ev)) {
        return;
      }
      if (_.isString(src) && src.slice(0, 1) == '/') {
        ev.preventDefault();
        this.doNavigate(this.cleanLinkHref(src));
        return false;
      }
    },
    doNavigate: function doNavigate(route) {
      Backbone.history.navigate(route, {
        trigger: true
      });
    }
  });
  return PushStateService;
});

